import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_112: DocMigration = {
  maxSchemaVersion: "0.0.112",
  description: "Basements",
  apply(json: any) {
    delete json.foundations;
    delete json.foundationSystems;

    if (json.rooms) {
      for (const roomId in json.rooms) {
        const room = json.rooms[roomId];
        if (room.attributes?.roomClass !== undefined) {
          if (room.attributes.roomClass > 0) {
            room.attributes.roomClass = room.attributes.roomClass + 1;
          }
        }
      }
    }

    if (json.settings) {
      const slabOnGrade = "SLAB_ON_GRADE";
      const slabOnGradeMono = "SLAB_ON_GRADE.MONOLITHIC";
      const slabOnGradeCIP = "SLAB_ON_GRADE.STEM_WALL_CIP";
      const slabOnGradeCMU = "SLAB_ON_GRADE.STEM_WALL_CMU";

      const raisedSlab = "RAISED_SLAB";
      const raisedSlabCMU = "RAISED_SLAB.STEM_WALL_CMU";

      const oldFoundationDetailMap = {
        [slabOnGradeMono]: {
          INTERIOR_EXTERIOR: "FOUND_TYP_TURNDOWN_INT_EXT",
          INTERIOR_BRICKLEDGE_EXTERIOR: "FOUND_TYP_TURNDOWN_INT_EXT_BRICK",
          INTERIOR_INTERIOR: "FOUND_TYP_TSLAB_INT_LBW",
          GARAGE_GARAGE: "FOUND_TYP_TSLAB_INT_LBW",
          PORCH_PORCH: "FOUND_TYP_TSLAB_INT_LBW",
          PORCH_EXTERIOR: "FOUND_TYP_TURNDOWN_POR_EXT",
          PORCH_BRICKLEDGE_EXTERIOR: "FOUND_TYP_TURNDOWN_POR_EXT_BRICK",
          INTERIOR_PORCH: "FOUND_TYP_TURNDOWN_INT_POR_SLAB",
          INTERIOR_BRICKLEDGE_PORCH: "FOUND_TYP_TURNDOWN_INT_POR_SLAB_BRICK",
          GARAGE_BRICKLEDGE_EXTERIOR: "FOUND_TYP_TURNDOWN_GAR_EXT_BRICK",
          INTERIOR_GARAGE: "FOUND_TYP_TURNDOWN_INT_GAR",
          GARAGE_EXTERIOR: "FOUND_TYP_TURNDOWN_GAR_EXT",
          GARAGE_PORCH: "FOUND_TYP_TURNDOWN_GAR_POR",
          GARAGE_BRICKLEDGE_PORCH: "FOUND_TYP_TURNDOWN_GAR_POR_BRICK",
          GARAGE_DOOR_EXTERIOR: "FOUND_TYP_TURNDOWN_GAR_EXT_DOOR",
          EXTERIOR_EXTERIOR: "NONE",
        },
        [slabOnGradeCIP]: {
          INTERIOR_EXTERIOR: "FOUND_TYP_STEM_CIP_INT_EXT",
          INTERIOR_BRICKLEDGE_EXTERIOR: "FOUND_TYP_STEM_CIP_INT_EXT_BRICK",
          INTERIOR_INTERIOR: "FOUND_TYP_STEM_CIP_INT_LBW",
          GARAGE_GARAGE: "FOUND_TYP_STEM_CIP_INT_LBW",
          PORCH_PORCH: "FOUND_TYP_STEM_CIP_INT_LBW",
          PORCH_EXTERIOR: "FOUND_TYP_STEM_CIP_POR_EXT",
          PORCH_BRICKLEDGE_EXTERIOR: "FOUND_TYP_STEM_CIP_POR_EXT_BRICK",
          INTERIOR_PORCH: "FOUND_TYP_STEM_CIP_INT_POR_SLAB",
          INTERIOR_BRICKLEDGE_PORCH: "FOUND_TYP_STEM_CIP_INT_POR_SLAB_BRICK",
          GARAGE_BRICKLEDGE_EXTERIOR: "FOUND_TYP_STEM_CIP_GAR_EXT_BRICK",
          INTERIOR_GARAGE: "FOUND_TYP_STEM_CIP_INT_GAR",
          GARAGE_EXTERIOR: "FOUND_TYP_STEM_CIP_GAR_EXT",
          GARAGE_PORCH: "FOUND_TYP_STEM_CIP_GAR_POR",
          GARAGE_BRICKLEDGE_PORCH: "FOUND_TYP_STEM_CIP_GAR_POR_BRICK",
          GARAGE_DOOR_EXTERIOR: "FOUND_TYP_STEM_CIP_GAR_EXT_DOOR",
          EXTERIOR_EXTERIOR: "NONE",
        },
        [slabOnGradeCMU]: {
          INTERIOR_EXTERIOR: "FOUND_TYP_STEM_CMU_INT_EXT",
          INTERIOR_BRICKLEDGE_EXTERIOR: "FOUND_TYP_STEM_CMU_INT_EXT_BRICK",
          INTERIOR_INTERIOR: "FOUND_TYP_STEM_CMU_INT_LBW",
          GARAGE_GARAGE: "FOUND_TYP_STEM_CMU_INT_LBW",
          PORCH_PORCH: "FOUND_TYP_STEM_CMU_INT_LBW",
          PORCH_EXTERIOR: "FOUND_TYP_STEM_CMU_POR_EXT",
          PORCH_BRICKLEDGE_EXTERIOR: "FOUND_TYP_STEM_CMU_POR_EXT_BRICK",
          INTERIOR_PORCH: "FOUND_TYP_STEM_CMU_INT_POR_SLAB",
          INTERIOR_BRICKLEDGE_PORCH: "FOUND_TYP_STEM_CMU_INT_POR_SLAB_BRICK",
          GARAGE_BRICKLEDGE_EXTERIOR: "FOUND_TYP_STEM_CMU_GAR_EXT_BRICK",
          INTERIOR_GARAGE: "FOUND_TYP_STEM_CMU_INT_GAR",
          GARAGE_EXTERIOR: "FOUND_TYP_STEM_CMU_GAR_EXT",
          GARAGE_PORCH: "FOUND_TYP_STEM_CMU_GAR_POR",
          GARAGE_BRICKLEDGE_PORCH: "FOUND_TYP_STEM_CMU_GAR_POR_BRICK",
          GARAGE_DOOR_EXTERIOR: "FOUND_TYP_STEM_CMU_GAR_EXT_DOOR",
          EXTERIOR_EXTERIOR: "NONE",
        },
        [raisedSlabCMU]: {
          INTERIOR_EXTERIOR: "FOUND_TYP_RSTEM_CMU_INT_EXT",
          INTERIOR_BRICKLEDGE_EXTERIOR: "FOUND_TYP_RSTEM_CMU_INT_EXT_BRICK",
          INTERIOR_INTERIOR: "FOUND_TYP_RSTEM_CMU_INT_LBW",
          GARAGE_GARAGE: "FOUND_TYP_RSTEM_CMU_INT_LBW",
          PORCH_PORCH: "FOUND_TYP_RSTEM_CMU_INT_LBW",
          PORCH_EXTERIOR: "FOUND_TYP_RSTEM_CMU_POR_EXT",
          PORCH_BRICKLEDGE_EXTERIOR: "FOUND_TYP_RSTEM_CMU_POR_EXT_BRICK",
          INTERIOR_PORCH: "FOUND_TYP_RSTEM_CMU_INT_POR_SLAB",
          INTERIOR_BRICKLEDGE_PORCH: "FOUND_TYP_RSTEM_CMU_INT_POR_SLAB_BRICK",
          GARAGE_BRICKLEDGE_EXTERIOR: "FOUND_TYP_RSTEM_CMU_GAR_EXT_BRICK",
          INTERIOR_GARAGE: "FOUND_TYP_RSTEM_CMU_INT_GAR",
          GARAGE_EXTERIOR: "FOUND_TYP_RSTEM_CMU_GAR_EXT",
          GARAGE_PORCH: "FOUND_TYP_RSTEM_CMU_GAR_POR",
          GARAGE_BRICKLEDGE_PORCH: "FOUND_TYP_RSTEM_CMU_GAR_POR_BRICK",
          GARAGE_DOOR_EXTERIOR: "FOUND_TYP_RSTEM_CMU_GAR_EXT_DOOR",
          EXTERIOR_EXTERIOR: "NONE",
        },
      };

      const oldDetailIds = {
        // foundation slab mono
        FOUND_TYP_TURNDOWN_INT_GAR: "FOUND_TYP_TURNDOWN_INT_GAR",
        FOUND_TYP_TURNDOWN_INT_POR_SLAB: "FOUND_TYP_TURNDOWN_INT_POR_SLAB",
        FOUND_TYP_TURNDOWN_INT_POR_SLAB_BRICK: "FOUND_TYP_TURNDOWN_INT_POR_SLAB_BRICK",
        FOUND_TYP_TURNDOWN_INT_EXT: "FOUND_TYP_TURNDOWN_INT_EXT",
        FOUND_TYP_TURNDOWN_INT_EXT_BRICK: "FOUND_TYP_TURNDOWN_INT_EXT_BRICK",
        FOUND_TYP_TURNDOWN_GAR_POR: "FOUND_TYP_TURNDOWN_GAR_POR",
        FOUND_TYP_TURNDOWN_GAR_POR_BRICK: "FOUND_TYP_TURNDOWN_GAR_POR_BRICK",
        FOUND_TYP_TURNDOWN_GAR_EXT: "FOUND_TYP_TURNDOWN_GAR_EXT",
        FOUND_TYP_TURNDOWN_GAR_EXT_BRICK: "FOUND_TYP_TURNDOWN_GAR_EXT_BRICK",
        FOUND_TYP_TURNDOWN_GAR_EXT_DOOR: "FOUND_TYP_TURNDOWN_GAR_EXT_DOOR",
        FOUND_TYP_TURNDOWN_POR_EXT: "FOUND_TYP_TURNDOWN_POR_EXT",
        FOUND_TYP_TURNDOWN_POR_EXT_BRICK: "FOUND_TYP_TURNDOWN_POR_EXT_BRICK",
        FOUND_TYP_TSLAB_INT_LBW: "FOUND_TYP_TSLAB_INT_LBW",
        // FOUND_TYP_TSLAB_INT_PL: "FOUND_TYP_TSLAB_INT_PL", // point load
        // foundation slab stem cmu
        FOUND_TYP_STEM_CMU_INT_GAR: "FOUND_TYP_STEM_CMU_INT_GAR",
        FOUND_TYP_STEM_CMU_INT_POR_SLAB: "FOUND_TYP_STEM_CMU_INT_POR_SLAB",
        FOUND_TYP_STEM_CMU_INT_POR_SLAB_BRICK: "FOUND_TYP_STEM_CMU_INT_POR_SLAB_BRICK",
        FOUND_TYP_STEM_CMU_INT_EXT: "FOUND_TYP_STEM_CMU_INT_EXT",
        FOUND_TYP_STEM_CMU_INT_EXT_BRICK: "FOUND_TYP_STEM_CMU_INT_EXT_BRICK",
        FOUND_TYP_STEM_CMU_GAR_POR: "FOUND_TYP_STEM_CMU_GAR_POR",
        FOUND_TYP_STEM_CMU_GAR_POR_BRICK: "FOUND_TYP_STEM_CMU_GAR_POR_BRICK",
        FOUND_TYP_STEM_CMU_GAR_EXT: "FOUND_TYP_STEM_CMU_GAR_EXT",
        FOUND_TYP_STEM_CMU_GAR_EXT_BRICK: "FOUND_TYP_STEM_CMU_GAR_EXT_BRICK",
        FOUND_TYP_STEM_CMU_GAR_EXT_DOOR: "FOUND_TYP_STEM_CMU_GAR_EXT_DOOR",
        FOUND_TYP_STEM_CMU_POR_EXT: "FOUND_TYP_STEM_CMU_POR_EXT",
        FOUND_TYP_STEM_CMU_POR_EXT_BRICK: "FOUND_TYP_STEM_CMU_POR_EXT_BRICK",
        FOUND_TYP_STEM_CMU_INT_LBW: "FOUND_TYP_STEM_CMU_INT_LBW",
        // foundation slab stem cip
        FOUND_TYP_STEM_CIP_INT_GAR: "FOUND_TYP_STEM_CIP_INT_GAR",
        FOUND_TYP_STEM_CIP_INT_POR_SLAB: "FOUND_TYP_STEM_CIP_INT_POR_SLAB",
        FOUND_TYP_STEM_CIP_INT_POR_SLAB_BRICK: "FOUND_TYP_STEM_CIP_INT_POR_SLAB_BRICK",
        FOUND_TYP_STEM_CIP_INT_EXT: "FOUND_TYP_STEM_CIP_INT_EXT",
        FOUND_TYP_STEM_CIP_INT_EXT_BRICK: "FOUND_TYP_STEM_CIP_INT_EXT_BRICK",
        FOUND_TYP_STEM_CIP_GAR_POR: "FOUND_TYP_STEM_CIP_GAR_POR",
        FOUND_TYP_STEM_CIP_GAR_POR_BRICK: "FOUND_TYP_STEM_CIP_GAR_POR_BRICK",
        FOUND_TYP_STEM_CIP_GAR_EXT: "FOUND_TYP_STEM_CIP_GAR_EXT",
        FOUND_TYP_STEM_CIP_GAR_EXT_BRICK: "FOUND_TYP_STEM_CIP_GAR_EXT_BRICK",
        FOUND_TYP_STEM_CIP_GAR_EXT_DOOR: "FOUND_TYP_STEM_CIP_GAR_EXT_DOOR",
        FOUND_TYP_STEM_CIP_POR_EXT: "FOUND_TYP_STEM_CIP_POR_EXT",
        FOUND_TYP_STEM_CIP_POR_EXT_BRICK: "FOUND_TYP_STEM_CIP_POR_EXT_BRICK",
        FOUND_TYP_STEM_CIP_INT_LBW: "FOUND_TYP_STEM_CIP_INT_LBW",
        // foundation raised slab stem cmu
        FOUND_TYP_RSTEM_CMU_INT_GAR: "FOUND_TYP_RSTEM_CMU_INT_GAR",
        FOUND_TYP_RSTEM_CMU_INT_POR_SLAB: "FOUND_TYP_RSTEM_CMU_INT_POR_SLAB",
        FOUND_TYP_RSTEM_CMU_INT_POR_SLAB_BRICK: "FOUND_TYP_RSTEM_CMU_INT_POR_SLAB_BRICK",
        FOUND_TYP_RSTEM_CMU_INT_EXT: "FOUND_TYP_RSTEM_CMU_INT_EXT",
        FOUND_TYP_RSTEM_CMU_INT_EXT_BRICK: "FOUND_TYP_RSTEM_CMU_INT_EXT_BRICK",
        FOUND_TYP_RSTEM_CMU_GAR_POR: "FOUND_TYP_RSTEM_CMU_GAR_POR",
        FOUND_TYP_RSTEM_CMU_GAR_POR_BRICK: "FOUND_TYP_RSTEM_CMU_GAR_POR_BRICK",
        FOUND_TYP_RSTEM_CMU_GAR_EXT: "FOUND_TYP_RSTEM_CMU_GAR_EXT",
        FOUND_TYP_RSTEM_CMU_GAR_EXT_BRICK: "FOUND_TYP_RSTEM_CMU_GAR_EXT_BRICK",
        FOUND_TYP_RSTEM_CMU_GAR_EXT_DOOR: "FOUND_TYP_RSTEM_CMU_GAR_EXT_DOOR",
        FOUND_TYP_RSTEM_CMU_POR_EXT: "FOUND_TYP_RSTEM_CMU_POR_EXT",
        FOUND_TYP_RSTEM_CMU_POR_EXT_BRICK: "FOUND_TYP_RSTEM_CMU_POR_EXT_BRICK",
        FOUND_TYP_RSTEM_CMU_INT_LBW: "FOUND_TYP_RSTEM_CMU_INT_LBW",
        // structural details
        STRUCT_TYP_CONN_POR_COL: "STRUCT_TYP_CONN_POR_COL",
      };

      //update detail catalog and flag old details

      let foundationDetailCatalogFound = false;

      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "DETAIL_CATALOG_SETTINGS") {
          for (const detailId in setting.details) {
            if (oldDetailIds[detailId]) {
              foundationDetailCatalogFound = true;
            }
            const detail = setting.details[detailId];
            detail.name = detail.prettyName;
          }
        }
      }

      let foundationSettingsFound = false;

      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "FOUNDATION_SETTINGS") {
          foundationSettingsFound = true;
          // flatten foundation settings

          let foundationHash;

          const superType = setting.foundationSuperSystemType ?? slabOnGrade;
          delete setting.foundationSuperSystemType;

          if (superType === slabOnGrade) {
            delete setting[raisedSlab];
            delete setting[raisedSlabCMU];

            const slabOnGradeSettings = setting[slabOnGrade] ?? {};
            delete setting[slabOnGrade];

            const subType = slabOnGradeSettings.foundationSubSystemType ?? "MONOLITHIC";
            delete slabOnGradeSettings.foundationSubSystemType;

            if (subType === "MONOLITHIC") {
              delete setting[slabOnGradeCIP];
              delete setting[slabOnGradeCMU];

              setting[slabOnGradeMono] = {
                ...slabOnGradeSettings,
                ...setting[slabOnGradeMono],
              };

              foundationHash = slabOnGradeMono;
            } else if (subType === "STEM_WALL_CMU") {
              delete setting[slabOnGradeMono];
              delete setting[slabOnGradeCIP];

              setting[slabOnGradeCMU] = {
                ...slabOnGradeSettings,
                ...setting[slabOnGradeCMU],
              };

              foundationHash = slabOnGradeCMU;
            } else if (subType === "STEM_WALL_CIP") {
              delete setting[slabOnGradeMono];
              delete setting[slabOnGradeCMU];

              setting[slabOnGradeCIP] = {
                ...slabOnGradeSettings,
                ...setting[slabOnGradeCIP],
              };

              foundationHash = slabOnGradeCIP;
            }
          } else if (superType === raisedSlab) {
            delete setting[slabOnGrade];
            delete setting[slabOnGradeMono];
            delete setting[slabOnGradeCMU];
            delete setting[slabOnGradeCIP];

            const raisedSlabSettings = setting[raisedSlab] ?? {};
            delete setting[raisedSlab];

            const subType = raisedSlabSettings.foundationSubSystemType ?? "STEM_WALL_CMU";
            delete raisedSlabSettings.foundationSubSystemType;

            if (subType === "STEM_WALL_CMU") {
              setting[raisedSlabCMU] = {
                ...raisedSlabSettings,
                ...setting[raisedSlabCMU],
              };

              foundationHash = raisedSlabCMU;
            }
          }

          if (foundationHash) {
            setting.foundationHash = foundationHash;
          }

          if (setting[foundationHash]) {
            delete setting[foundationHash].id;
          }

          // hard link the detailId from the old catalog to the foundationConditions,
          // since these are no longer stored in the codebase

          let foundationSystemSettingsFound = false;

          for (const key in setting) {
            if (oldFoundationDetailMap[key]) {
              foundationSystemSettingsFound = true;

              const systemSettings = setting[key];
              const systemDetails = oldFoundationDetailMap[key];

              if (systemSettings.foundationConditions !== undefined) {
                const conditions = systemSettings.foundationConditions;

                for (const condition in conditions) {
                  if (conditions[condition].detailId === undefined) {
                    conditions[condition].detailId = systemDetails[condition];
                  }
                }
              } else {
                systemSettings.foundationConditions = {};

                for (const condition in systemDetails) {
                  systemSettings.foundationConditions[condition] = {
                    detailId: systemDetails[condition],
                  };
                }
              }
            }
          }

          if (foundationDetailCatalogFound && !foundationSystemSettingsFound) {
            const systemSettings = { foundationConditions: {} };
            const systemDetails = oldFoundationDetailMap[slabOnGradeMono];

            for (const condition in systemDetails) {
              systemSettings.foundationConditions[condition] = {
                detailId: systemDetails[condition],
              };
            }

            setting[slabOnGradeMono] = systemSettings;
          }
        }
      }

      if (foundationDetailCatalogFound && !foundationSettingsFound) {
        const parent: any = Object.values(json.settingsSets).sort((a: any, b: any) => a.sortIndex - b.sortIndex)[0];
        const parentId: string = parent.id;

        const id = uid();

        const setting = {
          entityType: "SETTINGS",
          id,
          parentId,
          type: "FOUNDATION_SETTINGS",
          name: "Foundation Settings",
          sortIndex: 0,
        };

        const systemSettings = { foundationConditions: {} };
        const systemDetails = oldFoundationDetailMap[slabOnGradeMono];

        for (const condition in systemDetails) {
          systemSettings.foundationConditions[condition] = {
            detailId: systemDetails[condition],
          };
        }

        setting[slabOnGradeMono] = systemSettings;
        json.settings[id] = setting;
      }
    }

    return json;
  },
};

export default migration_0_0_112;
